"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var openerMap = {
    ')': '(',
    "'": "'",
    '"': '"',
    ']': '[',
    '}': '{',
};
var isOpener = function (char) { return Object.values(openerMap).indexOf(char) !== -1; };
var isClosingOf = function (char, potentialOpener) {
    return openerMap[char] === potentialOpener;
};
var splitByCommasAtCurrentLevelOnly = function (commaSeperated) {
    return commaSeperated
        .split('')
        .reduce(function (_a, curr, i) {
        var args = _a.args, currentEscape = _a.currentEscape, current = _a.current;
        if ((currentEscape.length === 0 && curr === ',') || i === commaSeperated.length - 1) {
            return {
                args: __spreadArray(__spreadArray([], args, true), [current + (curr === ',' ? '' : curr)], false),
                current: '',
                currentEscape: currentEscape,
            };
        }
        if (currentEscape.length === 0) {
            return {
                args: args,
                current: current + curr,
                currentEscape: isOpener(curr) ? __spreadArray([curr], currentEscape, true) : currentEscape,
            };
        }
        var head = currentEscape[0], rest = currentEscape.slice(1);
        if (isClosingOf(curr, head)) {
            return {
                args: args,
                current: current + curr,
                currentEscape: rest,
            };
        }
        return {
            args: args,
            current: current + curr,
            currentEscape: isOpener(curr) ? __spreadArray([curr], currentEscape, true) : currentEscape,
        };
    }, {
        currentEscape: [],
        args: [],
        current: '',
    })
        .args.map(function (r) { return r.trim(); });
};
exports.default = splitByCommasAtCurrentLevelOnly;
//# sourceMappingURL=splitByCommasAtCurrentLevelOnly.js.map